import i18n from "i18next";

const validate = (values, props) => {
    //const { t } = useTranslation();
    const errors = {};
    const requiredFields = [
        'firstName',
        'middleName',
        'lastName',
        'facultyNumber',
        'degree',
        'school',
        'isGraduated'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t("requiredField");
        }
    });

    const cvField = values["cvFile"];
    if (!props.cvName && (!cvField || !Array.isArray(cvField))) {
        errors["cvFile"] = i18n.t("cvRequired");
    }

    return errors;
};

export default validate;

//const validate = (values, props) => {
//    const errors = {}
//    const requiredFields = [
//        'firstName',
//        'middleName',
//        'lastName',
//        'facultyNumber',
//        'degree',
//        'school',
//        'isGraduated'
//    ];

//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = 'Полето е задължително';
//        }
//    });

//    const cvField = values["cvFile"];
//    if (!props.cvName && (!cvField || !Array.isArray(cvField))) {
//        errors["cvFile"] = 'Автобиографията е задължителна част от Вашия профил';
//    }

//    return errors
//}

//export default validate